
import { defineComponent } from 'vue';
import { useData } from '@/compositions/useData';

export default defineComponent({
  name: 'RequireRegistrationTemplate',

  setup(_) {
    document.title = '会員情報・設定';
    const data = useData();

    const reload = () => location.reload();

    return {
      surveyUrl: data.get('surveyUrl'),
      reload,
    };
  },
});
